import React from 'react'

const Component4 = () => {
  return (
    <div className='h-[50vh] bg-[#8c92a9] w-full flex justify-center items-center'>
      <div className="w-full flex justify-center items-center">
        <img className='w-1/2 h-[40vh]' src="https://cdn-icons-png.flaticon.com/512/580/580185.png" alt="" />
      </div>
    </div>
  )
}

export default Component4